import { Environment, EnvironmentConfig, Queue } from "../models/environment";
import { LanguageCode } from "../models/language";
import { UserDefaultType } from "../models/user";

export default function config(envs:Environment[]): EnvironmentConfig[] {
    const configs = envs.map(env => {

        const AXP_BASE_URL = getUrl(env, 'axp');
        const API_BASE_URL = getUrl(env, 'api');
        const STATIC_BASE_URL = getUrl(env, 'static');
        const API_ROOT_BASE_URL = getRootURL(env, 'api')
        return {
            env: env.env,
            bot: {
                name: env.bot.name
            },
            visible: env.visible,
            url: {
                axp: {
                    base: AXP_BASE_URL
                },
                api: {
                    base: API_BASE_URL,
                    auth: API_BASE_URL + env.envEndpoint.api.backend,
                    firestore: API_BASE_URL + env.envEndpoint.api.firestore,
                    saveTranscript: API_ROOT_BASE_URL + env.envEndpoint.api.saveTranscript,
                    engagementLanguage: API_ROOT_BASE_URL + env.envEndpoint.api.engagementLanguage
                },
                static: {
                    base: STATIC_BASE_URL,
                    assets: STATIC_BASE_URL + env.envEndpoint.static.media
                },
                gTranslate: {
                    base: API_ROOT_BASE_URL,
                },
                cloudFunction: {
                    base: API_ROOT_BASE_URL
                }
            },
            default_queue: env.default_queue,
            mandatory_properties: env.mandatory_properties,
            allowed_paths: env.allowed_paths,
            getMediaUrl: function (name: string) {
                return this.url.static.assets + '/' + name.split('/').pop();
            },
            auth: env.auth,
            getQueue: function (userContext: UserDefaultType):string{
                if (!env.dynamic_queue || !env.dynamic_queue.rules) return env.default_queue;
                const keys = Object.keys(env.dynamic_queue.rules)
                const value = userContext[env.dynamic_queue.user_value]
                const values = env.dynamic_queue.preprocessing(value as string)
                const queue = keys.find((queue) => {
                    if (env.dynamic_queue && queueIsValid(values, env.dynamic_queue.rules[queue])) {
                        return true
                }})
                if (queue) return queue
                return env.default_queue
            },
            getDefaultAgentLanguage: function (queueName: string): LanguageCode {
                if (!env.dynamic_queue) return ''
                const language = env.dynamic_queue.rules[queueName].default_agent_language || '';
                if (language) {
                    return language
                } else {
                    console.log('No default agent language found for queue', queueName, 'using en')
                }
                
                return language
            }
        };
    })
    return configs
}

function queueIsValid(values: Array<string>, queue: Queue) {
  
  if (queue.exclude_values && queue.exclude_values.some(val => values.includes(val))) return false;
  if (queue.accepted_values && queue.accepted_values.every(val => values.includes(val))) return true;
  return false
}

function getRootURL(env: Environment, type: string): string {
    const api = env.url[type];
    const protocol = purifyProtocol(api.protocol || env.protocol);
    const location = protocol + api.host;
    return location
}
function getUrl(env: Environment, type: string) {
    const api = env.url[type];
    const protocol = purifyProtocol(api.protocol || env.protocol);
    const location = protocol + api.host;
    const entrypoint = api.entrypoint;

    return [location, entrypoint].filter(Boolean).join('/');
}

function purifyProtocol(protocol: string) {
    const onFile = (protocol + '//').replace(/^file:\/\//, '.');
    return onFile;
}
